/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

//  import {LuiCommonModule} from '@angular/material/core';
import { CdkTableModule } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import {
  LuiCell,
  LuiCellDef,
  LuiColumnDef,
  LuiFooterCell,
  LuiFooterCellDef,
  LuiHeaderCell,
  LuiHeaderCellDef,
} from './cell';
import {
  LuiFooterRow,
  LuiFooterRowDef,
  LuiHeaderRow,
  LuiHeaderRowDef,
  LuiRow,
  LuiRowDef,
} from './row';
import { LuiRecycleRows, LuiTable } from './table';
import { LuiTextColumn } from './text-column';

const EXPORTED_DECLARATIONS = [
  // Table
  LuiTable,
  LuiRecycleRows,

  // Template defs
  LuiHeaderCellDef,
  LuiHeaderRowDef,
  LuiColumnDef,
  LuiCellDef,
  LuiRowDef,
  LuiFooterCellDef,
  LuiFooterRowDef,

  // Cell directives
  LuiHeaderCell,
  LuiCell,
  LuiFooterCell,

  // Row directives
  LuiHeaderRow,
  LuiRow,
  LuiFooterRow,

  LuiTextColumn,
];

@NgModule({
  imports: [CdkTableModule],
  declarations: EXPORTED_DECLARATIONS,
  exports: [EXPORTED_DECLARATIONS],
})
export class LuiTableModule {}
